import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import StarHalfIcon from "@mui/icons-material/StarHalf";
import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { SectionCard } from "./SectionCard";
import { colors } from "./theme";

interface PerformanceMetricsProps {
  averageCompletionTime: string; 
  onTimeDelivery: string; 
  customerSatisfaction: string; 
}

export const renderStars = (rating: number) => {
  const stars = [];
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating - fullStars >= 0.5;
  for (let i = 0; i < fullStars; i++) {
    stars.push(<StarIcon key={`full-${i}`} sx={{ color: colors.accent1 }} />);
  }
  if (hasHalfStar) {
    stars.push(<StarHalfIcon key="half" sx={{ color: colors.accent1 }} />);
  }
  const emptyStars = 5 - stars.length;
  for (let i = 0; i < emptyStars; i++) {
    stars.push(
      <StarBorderIcon key={`empty-${i}`} sx={{ color: colors.accent1 }} />
    );
  }
  return stars;
};

export const PerformanceMetrics: React.FC<PerformanceMetricsProps> = ({
  averageCompletionTime,
  onTimeDelivery,
  customerSatisfaction
}) => {
  return (
    <SectionCard title="Performance Metrics" icon={<StarIcon />}>
      <Grid container spacing={2} >
        {/* Average Completion Time */}
        <Grid item xs={12} sm={4} >
          <Box
            
            sx={{
              p: 3,
              borderRadius: 2,
              border: `1px solid ${colors.neutral2}30`,
              boxShadow: 1,
              backgroundColor: "#fff",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: 120,
              height: "100%"
            }}
          >
            <Typography
              variant="h4"
              sx={{ fontWeight: 700, color: colors.primary }}
            >
              {averageCompletionTime} hours
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{ color: colors.neutral3, mt: 1 }}
            >
              Avg. Completion Time
            </Typography>
          </Box>
        </Grid>

        {/* On-Time Delivery */}
        <Grid item xs={12} sm={4} >
          <Box
            sx={{
              p: 3,
              borderRadius: 2,
              border: `1px solid ${colors.neutral2}30`,
              boxShadow: 1,
              backgroundColor: "#fff",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: 120,
              height: "100%"
            }}
          >
            <Typography
              variant="h4"
              sx={{ fontWeight: 700, color: colors.primary }}
            >
              {onTimeDelivery}
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{ color: colors.neutral3, mt: 1 }}
            >
              On-Time Delivery
            </Typography>
          </Box>
        </Grid>

        {/* Customer Satisfaction */}
        <Grid item xs={12} sm={4} >
          <Box
            sx={{
              p: 3,
              borderRadius: 2,
              border: `1px solid ${colors.neutral2}30`,
              boxShadow: 1,
              backgroundColor: "#fff",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: 120,
              height: "100%"
            }}
          >
            {customerSatisfaction !== "N/A" &&
            customerSatisfaction !== undefined ? (
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                {renderStars(parseFloat(customerSatisfaction))}
              </Box>
            ) : (
              <Typography variant="h4">N/A</Typography>
            )}
            <Typography
              variant="subtitle1"
              sx={{ color: colors.neutral3, mt: 1 }}
            >
              Customer Satisfaction
            </Typography>
            <Typography variant="caption" sx={{ color: colors.neutral3 }}>
              (Rating is out of 5)
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </SectionCard>
  );
};

export default PerformanceMetrics;